<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Exchange Rates'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'ExchangeRateSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        lazy: '0',
        entityName: 'exchange-rate',
        editEntityScreen: 'Admin - Edit/View Exchange Rate',
        fields: [
          { header: 'From Currency', prop: (item) => item.fromCurrency.name },
          { header: 'To Currency', prop: (item) => item.toCurrency.name }
        ],
        shouldSearchForExactMatch: true,
        orderBy: 'fromCurrency'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/ExchangeRate/ExchangeRateSearchResults.vue